import React from 'react'
import CreateAsset from '../Asset/create/CreateAsset'

function Create() {
    return (
        <div className="CollectionAsset">
            <CreateAsset />
        </div>
    )
}

export default Create
